// Import model
import { DataviewLeadResponse } from '../models/DataviewLeadResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { DataView } from '../models/DataView';
import { FilterLeadRequest } from '../models/FilterLeadRequest';
import { Lead } from '../models/Lead';

// Import dependency serializers (for complex types)
import { DataViewSerializer } from './DataViewSerializer';
import { FilterLeadRequestSerializer } from './FilterLeadRequestSerializer';
import { LeadSerializer } from './LeadSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewLeadResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewLeadResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewLeadResponse instance
   */
  static deserialize(json: string): DataviewLeadResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewLeadResponse instance
   */
  static fromObject(obj: any): DataviewLeadResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewLeadResponse');
    }


    const instance: DataviewLeadResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        LeadSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterLeadRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewLeadResponse instances
   */
  static deserializeArray(json: string): DataviewLeadResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewLeadResponse instance to a JSON string
   */
  static serialize(instance: DataviewLeadResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewLeadResponse instance to a plain object
   */
  static toObject(instance: DataviewLeadResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        LeadSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterLeadRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewLeadResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewLeadResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
